import {
  Component, EventEmitter, Input, OnInit, Output, OnDestroy
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { LocaleConfig } from 'ngx-daterangepicker-material';
import {
  EMPTY, Subject, Subscription, catchError, interval
} from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { DOWNLOAD_ORDER } from 'src/app/constants/endpoint.const';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { LocaleConfigDate } from 'src/app/constants/date-config.const';
import { EXPEDITIONS_LIST, STATUS_ORDER } from 'src/app/constants/expeditions-list.const';

@Component({
  standalone: false,
  selector: 'modal-dl-order',
  templateUrl: './modal-download-data-order.component.html',
  styleUrls: ['./modal-download-data-order.component.scss'],
})
export class ModalDlDataOrder implements OnInit, OnDestroy {
  destroy$ = new Subject();
  selected = {
    startDate: moment().startOf('month').locale('id'),
    endDate: moment().endOf('month').locale('id'),
  };

  ranges: any = {
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'Last 60 Days': [moment().subtract(59, 'days'), moment()],
    Semua: [moment().startOf('year').subtract(1, 'year'), moment()],
  };

  invalidDates = [
    moment().add(2, 'days'),
    moment().add(3, 'days'),
    moment().add(5, 'days'),
  ];

  isInvalidDate = (m: moment.Moment) =>
    this.invalidDates.some((d) => d.isSame(m, 'day'));

  @Output() filterResult = new EventEmitter();

  setlocale: LocaleConfig = LocaleConfigDate;
  keepCalendarOpeningWithRange = true;

  status = STATUS_ORDER
  ekspedisi = EXPEDITIONS_LIST

  payment = [
    { value: 'COD', label: 'COD', id: 'COD', checked: true },
    { value: 'BANK TRANSFER', label: 'Bank Transfer', id: 'transfer', checked: true },
  ];

  selectedStatuses = this.status.map((s) => s.value);
  selectedPayment = this.payment.map((p) => p.value);
  selectedEkspedisi = this.ekspedisi.map((e) => e.value);
  selectedValue = 'order';
  isOrder = true;

    @Input() filterList: any = {
    start_date: moment().startOf('month').locale('id').format('YYYY-MM-DD 00:00:01'),
    end_date: moment().endOf('month').locale('id').format('YYYY-MM-DD 23:59:59'),
    shipping: this.ekspedisi.map((e) => e.value).join(','),
    payment_method: 'COD,BANK TRANSFER',
    order_status: this.status.map((s) => s.value).join(','),
    date_status: 'order',
  };

  progress = 0;
  txt_download = 'Download Excel';
  downloaded = false;
  downloading = false;
  intervalSubscription!: Subscription;

  regularEkspedisi: any[] = [];
  instantEkspedisi: any[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private toastService: ToastService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.regularEkspedisi = this.ekspedisi.filter(e => e.value !== 'GOSEND');
    this.instantEkspedisi = this.ekspedisi.filter(e => e.value === 'GOSEND');
  }

  onChangeDate(e: any) {
    const { startDate, endDate } = e;
    this.filterList.start_date = startDate?.format('YYYY-MM-DD 00:00:01') || this.selected.startDate.format('YYYY-MM-DD 00:00:01');
    this.filterList.end_date = endDate?.format('YYYY-MM-DD 23:59:59') || this.selected.endDate.format('YYYY-MM-DD 23:59:59');
    this.resetDownload();
    this.filterResult.emit(this.filterList);
  }

  onRadioChange() {
    this.isOrder = this.selectedValue === 'order';
    this.filterList.date_status = this.selectedValue;
    this.filterList.order_status = this.isOrder ? this.selectedStatuses.join(',') : '';
    this.resetDownload();
    this.filterResult.emit(this.filterList);
  }

  getStatus(event: any, list: any) {
    this.updateSelection(event, list.value, this.selectedStatuses, 'order_status');
  }

  getRadio(v: string) {
    this.filterList.order_status = v;
    this.resetDownload();
    this.filterResult.emit(this.filterList);
  }

  paymentMethod(event: any, item: any) {
    this.updateSelection(event, item.value, this.selectedPayment, 'payment_method');
  }

  selectEkspedisi(event: any, list: any) {
    this.updateSelection(event, list.value, this.selectedEkspedisi, 'shipping');
  }

  private updateSelection(event: any, value: string, list: string[], key: string) {
    const checked = event.target.checked;
    checked ? list.push(value) : list.splice(list.indexOf(value), 1);
    this.filterList[key] = list.length ? list.join(',') : '';
    this.resetDownload();
    this.filterResult.emit(this.filterList);
  }

  handleClose() {
    if (this.progress > 0 && this.progress < 100) {
      this.toastService.show(null, 'Download canceled', 'danger', {
        classname: 'bg-danger',
        delay: 3000,
      });
    }
    this.resetDownload();
    this.activeModal.dismiss();
    this.intervalSubscription.unsubscribe();
  }

  download() {
    const { order_status, payment_method, shipping } = this.filterList;

    if (!order_status && !payment_method && !shipping) {
      return this.showError('Select Order Status, Payment Method & Shipping First');
    }
    if (!order_status) return this.showError('Select Order Status First');
    if (!payment_method) return this.showError('Select Payment Method First');
    if (!shipping) return this.showError('Select Expedition First');

    this.progress = 0;
    this.downloading = true;
    this.downloaded = true;
    this.txt_download = 'Downloading...';

    this.toastService.show(null, 'The file will be downloaded soon, please wait', 'success', {
      classname: 'bg-success',
      delay: 3000,
    });

    this.intervalSubscription = interval(50).subscribe(() => {
      if (this.progress < 100) {
        this.progress++;
        return;
      }

      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
      });
      const params = new URLSearchParams(this.filterList).toString();
      this.http.get(`${DOWNLOAD_ORDER}?${params}`, { headers, responseType: 'blob' }).pipe(
        catchError(error => {
          console.error('Download failed:', error);
          this.showError('Download failed');
          this.resetDownload(true);
          return EMPTY;
        })
      ).subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${localStorage.getItem('auth-user')?.slice(1).replace(/\s+/g, '_')}Data_Order_${moment().format('YYYY-MM-DD')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();

        this.toastService.show(null, 'Successfully downloaded the file', 'success', {
          classname: 'bg-success',
          delay: 5000,
        });

        this.resetDownload(true);
      });

      this.intervalSubscription.unsubscribe();
    });
  }

  private resetDownload(clearText = false) {
    this.progress = 0;
    this.downloading = false;
    this.downloaded = false;
    if (clearText) this.txt_download = 'Download Excel';
  }

  private showError(message: string) {
    this.toastService.show(null, message, 'danger', {
      classname: 'bg-danger',
      delay: 3000,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }
}
